/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 09:50:40
 * @LastEditTime: 2020-08-11 11:47:38
 * @Description: 销售项目配方
 */

import axios from '@/utils/axios'

export const getRecipeSales = (payload) => {
    return axios.get('/recipeSales', {
        params: payload
    })
}

export const createRecipeSales = (data) => {
    return axios.post('/recipeSales', data)
}


export const getRecipeSalesById = (id) => {
    return axios.get(`/recipeSales/${id}`)
}
// 通过材料id获取配方
export const getRecipeContainMaterial = (id) => {
    return axios.get(`/recipe_contain_material/${id}`)
}

// 替换材料
export const bulkReplaceRecipeMaterial = (data) => {
    return axios.post(`/bulk_replace_recipe_material`, data);
}

export const getSalesCurrentRecipeProd = (id) => {
    return axios.get(`/prod_recipe_by_sales/${id}`)
}

export const verifyRecipeSales = (id, data) => {
    return axios.post(`/recipeSales/verify/${id}`, data)
}

export const verifyAllRecipe = (data) => {
    return axios.post(`/recipeSales/verifyAll`, data)
}

export const updateRecipeSales = (id, data) => {
    return axios.put(`/recipeSales/${id}`, data);
}

export const setProdRecipeSales = (id, data) => {
    return axios.post(`/set_prod_recipeSales/${id}`, data);
}

export const deleteRecipeSales = (id) => {
    return axios.delete(`/recipeSales/${id}`)
}

export const getRecipeSalesWithMaterialDetail = (id, data) => {
    return axios.get(`/recipe_sales_with_material_detail/${id}`, {
        params: data
    })
}